import { useEffect } from 'react';
import { useAuth } from '../features/auth/AuthProvider';
import { api } from './api';

/** The device's IANA time zone, e.g. «America/Mexico_City». */
const deviceTimeZone = (): string | null => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch {
    return null;
  }
};

/**
 * Keeps the account's time zone where the user actually is, so the emails the server sends
 * (the daily digest at 8:00, its «today» and «overdue») follow their clock. The interface itself
 * always formats in the device's local time. Renders nothing; mount it inside <AuthProvider>.
 */
export function AccountTimeZoneSync(): null {
  const { user, setUser } = useAuth();
  const saved = user?.timeZone;
  const signedIn = Boolean(user);

  useEffect(() => {
    if (!signedIn) return;
    const zone = deviceTimeZone();
    if (!zone || zone === saved) return;
    api.users.updateMe({ timeZone: zone }).then(setUser, () => undefined);
    // setUser changes identity on every render of the provider; the zone is what matters.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, saved]);

  return null;
}
